import React from 'react';
import axios from 'axios';

import { useModal } from '../Components/Modal/ModalContext';

import Loading from './Loading';

import styles from '../styles/DynamicModal.module.css';

const ChooseRegionForMailing = ({ idCase, onMailingSuccess }) => {
    const [regions, setRegions] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
    const [status, setStatus] = React.useState('');
    const [error, setError] = React.useState('');
    const [selectedRegion, setSelectedRegion] = React.useState(null);
    const { openModal } = useModal();

    const [isShowRegionsForMailing, setIsShowRegionsForMailing] = React.useState(false);

    React.useEffect(() => {
        axios.get('/api/regions')
        .then((response) => {
            if (response.data.length === 0) {
                setError('На данный момент в систему не добавлено ни одного региона. Обратитесь к администратору');
                setIsLoading(false);
            } else {
                setError('');
                setRegions(response.data);
                setIsLoading(false);
            }
        })
        .catch((error) => {
            console.error('Ошибка при получении данных:', error);
            setError('Ошибка при загрузке регионов ' + error.message || error.toString());
            setIsLoading(false);
        })
    }, [openModal]);

    const handleRegionSelect = (regionId) => {
        setIsLoading(true);
        setSelectedRegion(regionId);
        axios.post('/api/send-offer-case', {
            idRegion: regionId,
            idCase
        })
        .then(() => {
            setStatus('Рассылка успешно выполнена.');
            setIsLoading(false);
            setTimeout(() => {
                setStatus('');
                if (onMailingSuccess) {onMailingSuccess()};
            }, 2300);
        })
        .catch((error) => {
            const errorMessage = error.response?.data || 'Ошибка при выполнении рассылки.';
            setError(errorMessage);
            setIsLoading(false);
        })
    };

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : ( isShowRegionsForMailing ? (
                <>
                {!status &&
                    !error &&
                    <>
                        <a>Выберите регион для рассылки</a>
                        {regions.map((region) => (
                            <div className={styles.panelLine} key={region.id}>
                                <a>{region.name}</a>
                                <input
                                    type="radio"
                                    value={region.id}
                                    checked={String(region.id) === String(selectedRegion)}
                                    onChange={() => handleRegionSelect(region.id)}
                                />
                            </div>
                        ))}
                    </>
                }
                {error && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{error}</a>}
                {status && <a className={styles.statusPanel}><img src='/img/icons/check-circle.svg' alt='Статус' />{status}</a>}
                </>
                ) : (
                <>
                    <a>На данный момент не назначен</a>
                    <button type='button' className='button black' onClick={() => {setIsShowRegionsForMailing(true)}}>Выбрать регион для рассылки</button>
                </>
                )
            )}
        </>
    );
};

export default ChooseRegionForMailing;
